<template>
  <div>
    <q-card v-if="editParam">
      <ProcessoParadigma :model-value="form" />
    </q-card>
    <div class="col-12 q-px-sm" style="display: flex; justify-content: space-between;">
      <q-chip outline color="primary" text-color="white">
        Processos Paradigmas
      </q-chip>
      <q-btn v-if="edit && !editParam" outline rounded color="primary" label="Adicionar Processo" @click="adicionarItem" />
    </div>

    <q-list bordered separator>
      <template v-for="item in modelValue" :key="item">
        <q-item clickable v-ripple>
          <q-item-section>
            <slot name="item" :model-value="item" />
          </q-item-section>
          <q-item-section class="col-1" v-if="edit && !editParam">
            <q-btn flat icon="edit" @click.stop="editItem(item)" />
          </q-item-section>
          <q-item-section class="col-1" v-if="edit">
            <q-btn flat icon="delete_outline" @click.stop="remove(item)" />
          </q-item-section>
        </q-item>
      </template>
    </q-list>
  </div>
</template>

<script setup>
import {
  defineProps,
  ref,
  defineEmits,
  getCurrentInstance,
  computed,
  onMounted
} from "vue";
import ProcessoParadigma from "@/components/gr/GrProcessoPje.vue";

const props = defineProps({ modelValue: { type: Array } });
const emit = defineEmits(["update:modelValue"]);

const form = ref();
const editParam = ref();

const instance = getCurrentInstance();
const formParent = p =>
  !p.parent || p.parent.type.__name == "AppEditForm"
    ? p.parent
    : formParent(p.parent);
const editForm = formParent(instance.parent);
const edit = computed(() => editForm?.exposed?.edit.value );

emit
const remove = item => {
  emit("update:modelValue", props.modelValue.filter(e => e !== item));
}

const editItem = item => {
  form.value = { ...item };
  editParam.value = true;
  emit("update:modelValue", props.modelValue.filter(e => e !== item));
}

const adicionarItem = () => {
  editParam.value = true;
}

onMounted(() => {
  emit("update:modelValue", []);
});

</script>


